import { FAQId } from "./FAQId";
import { FAQTitle } from "./FAQTitle";
import { FAQContent } from "./FAQContent";
import { DateTime } from "../fundamental/DateTime";

const FAQType = Symbol();

export class FAQ {
    [FAQType]: any;
    readonly id: FAQId;
    readonly title: FAQTitle;
    readonly content: FAQContent;
    readonly createdTime: DateTime;

    private constructor(
        id: FAQId,
        title: FAQTitle,
        content: FAQContent,
        createdTime: DateTime
    ) {
        this.id = id;
        this.title = title;
        this.content = content;
        this.createdTime = createdTime;
    }

    static from(
        id: FAQId,
        title: FAQTitle,
        content: FAQContent,
        createdTime: DateTime
    ): FAQ {
        return new FAQ(id, title, content, createdTime);
    }
}

export type FAQJson = {
    id: string,
    title: string,
    content: string,
    createdTime: string
};
